{
  "boundary": {
    "title": "Something went wrong",
    "description": "This part of the page could not be displayed. Your work has not been lost — any run already started is still going on the server.",
    "reference": "Reference: {{reference}}"
  },
  "route": {
    "title": "This page could not be loaded",
    "description": "Try again, or go back to your projects."
  },
  "notFound": {
    "title": "Page not found",
    "description": "The page you asked for does not exist, or you no longer have access to it."
  },
  "api": {
    "offline": {
      "title": "Cannot reach Planetra",
      "description": "Your connection dropped, or the service is not responding. Anything already running continues on the server."
    },
    "unauthenticated": {
      "title": "Please sign in again",
      "description": "Your session has ended."
    },
    "forbidden": {
      "title": "You do not have access",
      "description": "This belongs to an organisation you are not a member of, or your role does not allow it. Check which organisation is selected."
    },
    "notFound": {
      "title": "Not found",
      "description": "This no longer exists, or you no longer have access to it."
    },
    "conflict": {
      "title": "This changed since you opened it",
      "description": "Somebody else has changed it. Reload to see the current version before trying again."
    },
    "gone": {
      "title": "This link has expired",
      "description": "Download links are short-lived. Ask for a new one."
    },
    "validation": {
      "title": "Check the highlighted fields",
      "description": "Some of what you entered could not be accepted."
    },
    "rateLimited": {
      "title": "Too many attempts",
      "description": "Wait a moment before trying again.",
      "descriptionAfter": "Try again in {{seconds}} seconds."
    },
    "server": {
      "title": "Something went wrong on our side",
      "description": "This is not your doing. Try again in a moment — if it keeps happening, contact support."
    },
    "unknown": {
      "title": "Something went wrong",
      "description": "The request did not complete. Try again."
    },
    "cancelled": {
      "title": "Cancelled",
      "description": "The request was stopped."
    },
    "codes": {
      "session_revoked": {
        "title": "You were signed out",
        "description": "This session was signed out from another device. Sign in again to continue."
      },
      "oauth_failed": {
        "title": "Google sign-in did not complete",
        "description": "Signing in with Google was not completed. Try again, or use your email and password."
      },
      "oauth_email_unverified": {
        "title": "Your Google email is not verified",
        "description": "Verify your email address with Google, then try again."
      },
      "oauth_account_exists": {
        "title": "An account already uses this email",
        "description": "Sign in with your email and password instead."
      }
    },
    "offlineBanner": {
      "label": "Connection status",
      "message": "You are offline. Planetra will reconnect on its own."
    }
  }
}
